var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-row',{staticClass:"noselect",attrs:{"no-gutters":"","align":"center","justify":"center"}},_vm._l((_vm.Valores),function(item){return _c('item',{staticClass:"mx-1",attrs:{"Item":item,"Cargando":_vm.Cargando}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }